












































































































































































// decoradores
import {Component, Emit, Prop, Vue} from "vue-property-decorator";
// tipos
import {HeadersDataTable} from "@/typings/vuetify/vDataTable";
import { SaldoCuenta } from "@/typings/store/plugins/easyFirestore/saldoCuentas";
import {ItemsTablaSaldoCuentas} from "@/typings/components/saldoCuentas/tabla";
import "@/helpers/extensions";

@Component
export default class TablaSaldoCuentas extends Vue {
  @Prop() readonly opciones!: boolean;
  @Prop() readonly search!: string;
  @Prop() readonly saldoCuentas!: Array<SaldoCuenta>;

  options = {
    itemsPerPage: -1,
  };
  headerProps = {
    sortIcon: "mdi-chevron-down"
  }

  get headers(): HeadersDataTable {
    return [
      //{text: "", value: "estado", sortable: false},
      {text: "Nombre", value: "nombre"},
      {text: "Posicion", value: "posicion"},
      {text: "", value: "opciones", sortable: false}
    ];
  }

  get items(): ItemsTablaSaldoCuentas {
    return this.saldoCuentas.map((saldoCuenta) => {
      const nombre = saldoCuenta.nombre;
      const posicion = saldoCuenta.posicion;
    
      return {
        nombre,
        posicion,
       
        data: saldoCuenta,
      };
    });
  }

//   actualizarEstado(item: Usuario): void {
//     let estado: EstadoUsuario;
//     item.estado === 'libre' ? estado = 'bloqueado' : estado = 'libre';
//     item.estado = estado;
//     this.onCambiarEstado(item);
//   }

//   @Emit("cambiar-estado")
//   onCambiarEstado(usuario: Usuario): Usuario {
//     return usuario;
//   }

  @Emit("abrir-info")
  onAbrirInfo(saldoCuenta: SaldoCuenta): SaldoCuenta {
    return saldoCuenta;
  }

  @Emit("abrir-editar")
  onAbrirEditar(saldoCuenta: SaldoCuenta): SaldoCuenta {
    return saldoCuenta;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(saldoCuenta: SaldoCuenta): SaldoCuenta {
    return saldoCuenta;
  }
}
